import * as React from 'react';

import { SelectionsButton } from '../../components/SelectionsButton';
import { trackSelectionButtonClick } from './tracking';
import { useApplicationContext } from '../../utils/applicationContext';
import { getNewbuildingSelectionsUrl } from '../../utils/config';

export function ActionButtonContainer() {
  const { config } = useApplicationContext();
  const selectionsUrl = getNewbuildingSelectionsUrl(config);

  const onSelectionsButtonClick = React.useCallback(() => {
    trackSelectionButtonClick();
  }, []);

  return <SelectionsButton onClick={onSelectionsButtonClick} href={selectionsUrl} />;
}
